import { render, staticRenderFns } from "./Add-demo.vue?vue&type=template&id=3e127cf8&scoped=true"
import script from "./Add-demo.vue?vue&type=script&lang=js"
export * from "./Add-demo.vue?vue&type=script&lang=js"
import style0 from "./Add-demo.vue?vue&type=style&index=0&id=3e127cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e127cf8",
  null
  
)

export default component.exports